var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScheduleareport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 7H17M4 1V4M5 10H4M8 10H7M11 10H10M14 10H13M5 12H4M8 12H7M11 12H10M14 12H13M5 14H4M8 14H7M11 14H10M14 14H13M5 16H4M8 16H7M11 16H10M14 16H13M14 1V4M16 3H2C1.447 3 1 3.448 1 4V18C1 18.552 1.447 19 2 19H16C16.553 19 17 18.552 17 18V4C17 3.448 16.553 3 16 3Z",
    stroke: "#76828F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleareport);
export default __webpack_public_path__ + "static/media/scheduleareport.5da896a154f9a4420a609aba60e61374.svg";
export { ForwardRef as ReactComponent };